import React, { ChangeEvent, ReactElement, useEffect, useMemo } from 'react';
import { DocCompType } from '../../redux/reducers/companyDetailsReducer';
import {
    FormControl,
    Grid2,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from '@mui/material';
import { useAppDispatch } from '../../hooks/hooks';
import {
    removeDocumentReceiverTemplate,
    updateLabelForDocumentReceiverTemplate,
    updateValueForDocumentReceiverTemplate,
} from '../../redux/actions/companyDetailsActions';
import DeleteIcon from '@mui/icons-material/Delete';
import { ClientDto } from '../../api/ClientApi';
import { translateClientField } from './CompanyDetailsHelper';

type DocumentReceiverDataTemplateProps = {
    documentReceiverTemplates: DocCompType[] | undefined;
    docData: DocCompType | undefined;
};

export default function DocumentReceiverDataTemplate(props: DocumentReceiverDataTemplateProps): ReactElement {
    const { docData, documentReceiverTemplates } = props;

    const dispatch = useAppDispatch();

    const allValues = () => {
        return Object.keys(new ClientDto()).filter((val) => {
            return (
                val === 'name' ||
                val === 'shortName' ||
                val === 'phone' ||
                val === 'address' ||
                val === 'state' ||
                val === 'city' ||
                val === 'ucin' ||
                val === 'taxId' ||
                val === 'email'
            );
        });
    };

    const availableValues = useMemo(() => {
        return Object.keys(new ClientDto())
            .filter((val) => {
                return (
                    val === 'name' ||
                    val === 'shortName' ||
                    val === 'phone' ||
                    val === 'address' ||
                    val === 'state' ||
                    val === 'city' ||
                    val === 'ucin' ||
                    val === 'taxId' ||
                    val === 'email'
                );
            })
            .filter((val) => {
                const index = documentReceiverTemplates?.findIndex((drt) => drt.value === val);
                return index === undefined || index < 0 || docData?.value === val;
            });
    }, [documentReceiverTemplates, docData]);

    const handleChangeLabel = (e: ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;

        dispatch(updateLabelForDocumentReceiverTemplate({ index: docData?.index ?? 0, label: val }));
    };

    const handleSelectFieldName = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;

        dispatch(updateValueForDocumentReceiverTemplate({ index: docData?.index ?? 0, value: value }));
    };

    const handleRemoveReceiverTemplate = () => {
        dispatch(removeDocumentReceiverTemplate(docData?.index ?? 0));
    };

    return !docData ? (
        <></>
    ) : (
        <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, md: 5 }}>
                <TextField
                    error={!!docData?.label && docData?.label !== '' ? false : true}
                    required
                    fullWidth
                    name="label"
                    label="Labela"
                    value={!!docData?.label ? docData?.label : ''}
                    variant="outlined"
                    onChange={handleChangeLabel}
                />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 5 }}>
                <FormControl fullWidth error={!!docData?.value ? false : true} required>
                    <InputLabel id="demo-simple-select-label">Naziv polja</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={docData?.value ?? ''}
                        label="Naziv polja"
                        onChange={handleSelectFieldName}
                    >
                        {availableValues?.map((dt) => {
                            return (
                                <MenuItem key={dt} value={dt}>
                                    {translateClientField(dt)}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 2 }} sx={{ textAlign: 'center' }}>
                <IconButton color="error" onClick={handleRemoveReceiverTemplate}>
                    <DeleteIcon color="error" />
                </IconButton>
            </Grid2>
        </Grid2>
    );
}
